import React from 'react'
import { connect } from 'react-redux'
import { userLogout } from 'store/modules/auth/actions'

class LogoutContainer extends React.Component {

    componentDidMount(props) {
        const { userLogout, loggedIn, history } = this.props;
        if (loggedIn) {
            userLogout();
        } else {
            history.push('/')
        }
    }

    componentDidUpdate(prevProps) {
        const { loggedIn, history } = this.props;

        if (!loggedIn) {
            history.push('/')
        }
    }

    render() {
        return null
    }

}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.auth.loggedIn,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        userLogout: () => {
            dispatch(userLogout())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutContainer)